<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to="/book/new"><i class="fa fa-plus"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid">

	<div class="card" v-if="dataReady">
			<div class="card-block">

				<div class="row">
					<div class="col-sm-4">
						<div class="md-form form-sm">
							<i class="fa fa-tag prefix"></i>
							<f-category v-model="filter.categories" @input="fetchData()" cplaceholder="Търсене по категория"></f-category>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="md-form form-sm">
							<i class="fa fa-search prefix"></i>
							<input type="text" v-model="search" @keyup.enter="fetchData()" class="form-control" placeholder="Търсене по заглавие, автор, издателство, описание">
						</div>
					</div>
					<div class="col-sm-3">
						<div class="md-form form-sm">
							<i class="fa fa-search prefix"></i>
							<f-family v-model="filter.family" @input="fetchData()" cplaceholder="Търсене по семейство"></f-family>
						</div>
					</div>
					<div class="col-sm-2">
						<f-select v-model="filter.status" :values="$config.lists.bookStatuses" :hide-name="true" @input="fetchData()" allow-none cplaceholder="Търсене по статус"></f-select>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
					<table class="table table-striped table-no-bordered table-hover table-responsive" cellspacing="0" width="100%">
						<thead>
								<tr>
									<th style="width: 60px;"></th>
									<th class="sorting_asc" tabindex="0">Заглавие</th>
									<th class="sorting" tabindex="0">Автор</th>
									<th class="sorting" tabindex="0">Издателство</th>
									<th class="sorting" tabindex="0">Статус</th>
									<th class="sorting" tabindex="0">Семейство</th>
									<th class="disabled-sorting text-right sorting" tabindex="0" style="width: 100px;">Действие</th>
								</tr>
						</thead>
						<tbody>
								<tr v-for="item in records.items" role="row">
									<td class="vertical-middle">
										<img alt="" :src="item.image || '/network/static/img/default_book.jpg'" style="width:50px; float:left; margin: 5px;">
									</td>
									<td class="vertical-middle">{{ item.title }}<br>
										<c-categories :value="item.categories"></c-categories></td>
									<td class="vertical-middle">{{ item.author }}</td>
									<td class="vertical-middle">{{ item.publisher }}</td>
									<td class="vertical-middle"><span :class="'tag badge badge-' + $config.lists.bookStatuses[item.status].style">{{ $t('status.book_' + item.status) }}</span></td>
									<td class="vertical-middle">
										<div class="text-center float-left">
											<span v-if="item.taker">на</span><br>
											<c-avatar :family="item.family" class="float-left"></c-avatar>
										</div>
										<div class="text-center float-left" v-if="item.taker">
											при<br>
											<c-avatar :family="item.taker"></c-avatar>
											<br>до<br>  {{ item.takerDueDate | prettyDate }}
										</div>
										<div class="text-center float-left" v-if="item.takerExternal" style="max-width: 100px;">
											при<br>
											[{{ item.takerExternal }}]
											<br>до<br>  {{ item.takerDueDate | prettyDate }}
										</div>
									</td>
									<td class="vertical-middle text-right text-nowrap">
										<router-link :to="'/book/' + item.id" class="btn btn-small btn-primary btn-icon"><i class="fa fa-eye"></i></router-link>
										<template v-if="canEdit(item)">
											<router-link :to="'/book/' + item.id + '/edit'" class="btn btn-small btn-warning btn-icon"><i class="fa fa-edit"></i></router-link>
											<button type="button" @click="remove(item.id)" class="btn btn-small btn-danger btn-icon m-0"><i class="fa fa-remove"></i></button>
										</template>
									</td>
								</tr>
							</tbody>
					</table>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12">
				<f-pager :total="records.total" :clickhandler="pageClick"></f-pager>
			</div>
		</div>
		</div>

	</div><!--	end card	-->

</div>
</div>
</template>

<script>
module.exports = {
	data: function () {
		return {
			dataReady: false,
			records: {},
			search: '',
			filter: {
				categories: '',
				status: '',
				family: undefined
			},
			page: 1
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			var query = []; // From https://stackoverflow.com/a/1714899
			var filter = Object.assign({}, this.filter, {
				family: this.filter.family && this.filter.family.id
			});
			for (var key in filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(filter[key]));
				}
			}

			if (this.search) {
				query.push('search=' + encodeURIComponent(this.search));
			}

			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);
			this.$http.get('backend://book?' + query.join('&')).then((result) => {
				this.records = result.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		remove: function (id) {
			if (!confirm('Сигурни ли сте че искате да изтриете този ресурс?')) {
				return;
			}
			this.$http.delete('backend://book/' + id).then((result) => {
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		canEdit: function (resource) {
			return resource.family.id + '' === this.$user.familyUser.family.id + '';
		},
		pageClick: function (page) {
			this.page = page;
			this.fetchData();
		}
	}
};
</script>
<style>
td.vertical-middle {
	vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// Books.vue?4635cd2a